// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"Uaa-z","colorTextValue":"Vaa-z","swatches":"Waa-z","collapseLink":"Xaa-z","isCollapsed":"Yaa-z","dropdown":"Zaa-z","disabled":"_aa-z"};